import React from 'react';
import { PlusIcon, MagnifyingGlassIcon } from '@heroicons/react/24/outline';

const LectureFilter = ({ searchQuery, setSearchQuery, setShowUploadModal }) => {
  return (
    <div className="mb-1 flex-shrink-0">
      <div className="bg-white/80 backdrop-blur-xl rounded-xl shadow-lg border border-white/20 p-4 relative overflow-hidden">
        <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-blue-400/10 to-indigo-500/10 rounded-full -translate-y-16 translate-x-16"></div>
        <div className="absolute bottom-0 left-0 w-24 h-24 bg-gradient-to-tr from-purple-400/10 to-pink-400/10 rounded-full translate-y-12 -translate-x-12"></div>

        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <div className="p-1.5 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg shadow-lg">
              <i className="pi pi-filter text-white text-xs"></i>
            </div>
            <div>
              <h3 className="text-sm font-bold text-gray-900">My Lectures</h3>
              <p className="text-xs text-gray-600 mt-0.5">Manage and share your course materials</p>
            </div>
          </div>
          <button onClick={() => setShowUploadModal(true)} className="lectures-upload-btn">
            <PlusIcon className="lectures-upload-icon" />Upload Lecture
          </button>
        </div>

        <div className="flex items-center gap-2">
          <div className="flex-1 relative">
            <MagnifyingGlassIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
            <input type="text" placeholder="Search lectures by title or description..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)}
              className="lectures-search-input"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LectureFilter;
